import PropTypes from 'prop-types';
import Input from '../../ui/Input';
import Select from '../../ui/Select';

const FiltrosFila2 = ({
  searchContext, isTableNotLoading, headquarter, headquarterList,
  type, typeList, cicle, cicleList, course, courseList, email, userOU,
  handleHeadquarter, handleType, handleCicle, handleCourse, handleEmailOnChange,
}) => {
  const hasRestoredSearch = searchContext !== '' && searchContext.newSearch === false;

  const isModalidadDisabled =
    !isTableNotLoading ||
    !['CNTEC', 'CEDESCA', 'SUPERADMIN', 'SECRETARÍA', 'SEDE', 'ORIENTACIÓN'].includes(userOU.centro);

  const typeValue =
    !['CNTEC', 'CEDESCA', 'SUPERADMIN', 'SECRETARÍA', 'SEDE', 'ORIENTACIÓN'].includes(userOU.centro)
      ? 'O' : type;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px', marginBottom: '12px' }}>
      <Select label="Centro" name="centros" id="centros" onChange={handleHeadquarter}
        disabled={!isTableNotLoading} value={headquarter}
        options={headquarterList && headquarterList.length > 0 ? headquarterList : []} />
      <Select label="Modalidad" name="modalidad" id="modalidad" onChange={handleType}
        disabled={isModalidadDisabled} value={typeValue}
        options={typeList && typeList.length > 0 ? typeList : []} />
      <Select label="Grado" name="grado" id="grado" onChange={handleCicle}
        disabled={!isTableNotLoading} value={cicle}
        options={cicleList && cicleList.length > 0 ? cicleList : []} />
      <Select label="Curso" name="curso" id="curso" onChange={handleCourse}
        disabled={!isTableNotLoading} value={course}
        options={courseList && courseList.length > 0 ? courseList : []} />
      <Input label="Email" type="email" name="email" id="email" placeholder="Email"
        onChange={handleEmailOnChange} onInput={handleEmailOnChange}
        defaultValue={hasRestoredSearch ? email.data : ''} disabled={!isTableNotLoading}
        error={email.error === 'format' ? 'Formato incorrecto' : undefined} />
    </div>
  );
};

FiltrosFila2.propTypes = {
  searchContext: PropTypes.object, isTableNotLoading: PropTypes.bool,
  headquarter: PropTypes.string, headquarterList: PropTypes.array,
  type: PropTypes.string, typeList: PropTypes.array,
  cicle: PropTypes.string, cicleList: PropTypes.array,
  course: PropTypes.string, courseList: PropTypes.array,
  email: PropTypes.object, userOU: PropTypes.object,
  handleHeadquarter: PropTypes.func, handleType: PropTypes.func,
  handleCicle: PropTypes.func, handleCourse: PropTypes.func,
  handleEmailOnChange: PropTypes.func,
};

export default FiltrosFila2;
